import React, {Component} from 'react';

import './styles.scss';
import {PieChart} from 'react-easy-chart';

class SegmentLoyalty extends Component {

    render() {
        return (
            <div className={"segment"}>
                <PieChart
                    size={57}
                    data={[{key: this.props.key, value: this.props.percentage*360/100, color: '#FBCE07'},
                        {key: this.props.key2, value: 360-(this.props.percentage*360/100), color: '#F0F0F0'}]}
                />
                <div className={"data"}>
                    <div className={"values"}>
                        <div className={"main-value"}>{this.props.mainValue}</div>
                        <div className={"percentage"}>{isNaN(this.props.percentage) ? ' - ' : this.props.percentage}%</div>
                    </div>
                    <div className={"comment"}>{this.props.comment}</div>
                    <div className={"percentage-volume"}>{this.props.percentageVolume}%</div>
                    <div className={"comment"}>Volumen capturado*</div>
                </div>
            </div>
        );
    }
}

export default SegmentLoyalty;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/associatesBehavior/components/segmentLoyalty/SegmentLoyalty.js